import { createFileRoute } from "@tanstack/react-router";
import { listFeatureFlags, listUserFeatureFlags } from "api-client";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminFeatureFlagAccessPage } from "src/pages/AdminFeatureFlagsPage";

import { FEATURE_FLAGS_DEFAULT_PAGE_SIZE } from "./route";

const routeSearchSchema = z.object({
  flagName: z.string().optional(),
  userEmail: z.string().optional(),
  add: z.boolean().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute(
  "/_auth/_admin/admin/feature-flags/access",
)({
  component: AdminFeatureFlagAccessPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: (args) => {
    return args.search;
  },
  async loader(args) {
    return await loaderHandler(async () => {
      const deps = args.deps;
      const page = deps.p ?? 0;
      const pageSize = deps.ps ?? FEATURE_FLAGS_DEFAULT_PAGE_SIZE;

      const results = await Promise.all([
        listUserFeatureFlags({
          query: {
            pageIndex: page,
            pageSize: pageSize,
            flagName: deps.flagName,
            userEmail: deps.userEmail,
          },
        }).then((response) => {
          return response.data.data;
        }),
        listFeatureFlags({
          query: {
            pageIndex: 0,
            pageSize: 100,
          },
        }).then((response) => {
          return response.data.data.currentPage;
        }),
      ]);
      const assignments = results[0];
      const featureFlags = results[1];

      return {
        data: {
          assignments: assignments.currentPage,
          pageInfo: assignments.pageInfo,
          availableFlags: featureFlags,
          pageSize: pageSize,
        },
      };
    });
  },
});
